import React, { PropsWithChildren } from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { BaseLayout } from './BaseLayout';
import { Avatar, Paper } from '../components/mui';

export interface PublicLayoutProps extends PropsWithChildren<any> {}

const PublicLayout = React.memo(({ children }: PublicLayoutProps): React.ReactNode => {
   return (
      <BaseLayout>
         <div className="screen">
            <main className="flex justify-center items-center w-full">
               <Paper className="p-6 flex flex-col w-full max-w-[450px] items-center" elevation={10}>
                  <Avatar className="bg-secondary m-2">
                     <LockOutlinedIcon />
                  </Avatar>
                  {children}
               </Paper>
            </main>
         </div>
      </BaseLayout>
   );
});

export default PublicLayout;
export { PublicLayout };
